// extracted by mini-css-extract-plugin
module.exports = {"wrap":"card-bonus_wrap__c9umV","text":"card-bonus_text__YJS7Y"};